import Button from '@eduzz/houston-ui/Button';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import Alert from 'components/Alert';
import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { useCallback, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import chargebackService from 'v2/services/chargeback';

import { useStyles } from '../styles';

const ExportChargeback = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [totalItems] = useObservable(() => chargebackService.getTotalItems(), []);
  const classes = useStyles();

  const [exportReport] = useCallbackObservable(() => {
    setLoading(true);
    return chargebackService.export().pipe(
      tap((data) => {
        const dateExport = moment(new Date()).format('DD-MM-YYYY');
        let fileExport = new Blob([data as any], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `chargeback-${dateExport}.csv`);
        setLoading(false);
      }),
      catchError(() => {
        setLoading(false);
        return of(true);
      })
    );
  }, []);

  const handleExport = useCallback(async () => {
    if (totalItems > 3000) {
      await Alert.show({
        title: 'Atenção',
        message: 'É possível exportar no máximo 3 mil registros por relatório. Refaça o filtro para poder exportar.',
      });
      return;
    }

    exportReport();
  }, [exportReport, totalItems]);

  return (
    <Button
      className={classes.exportBtn}
      disabled={!totalItems}
      onClick={handleExport}
      variant='text'
      loading={loading}
      startIcon={<SystemUpdateAltIcon />}
    >
      Exportar
    </Button>
  );
};

export default ExportChargeback;
